import React, { Component } from 'react';
import { Drawer, Row, Col, Card, Icon } from 'antd';
import { connect } from 'react-redux';
import { getPushPathWrapper } from '../../../routes';

import { GetDashboardCount } from '../../dashboard/actions';
import DashboardFilter from '../../dashboard/dashboardFilters';

const oldArticleStatusList = [
  { title: 'Old Submissions', status: 'Online Submissions', icon: 'profile', value: 0, path: 'onlineSubmission.oldSubmissions' },
  { title: 'Article Submissions', status: 'Article Submissions', icon: 'profile', value: 0, path: 'onlineSubmission.articleSubmissions' },
  { title: 'Submitted Manuscript', status: 'Submitted Article', icon: 'laptop', value: 0, path: 'article.submittedArticles' },
  { title: 'Under Process', status: 'Under Process', icon: 'bar-chart', value: 0, path: 'article.underProcess' },
  { title: 'Under Review', status: 'Under Reviewer', icon: 'question-circle', value: 0, path: 'article.underReviewer' },
  { title: 'Reviewed Manuscript', icon: 'mail', value: 0, path: 'article.reviewedArticles', status: 'Reviewed Comments' },
  { title: 'Comments To Author', status: 'Comments To Author', icon: 'upload', value: 0, path: 'article.commentsToAuthor' },
  { title: 'Rejected Manuscript', status: 'Rejection', icon: 'delete', value: 0, path: 'article.rejection' },
  { title: 'Revised Manuscript', icon: 'message', value: 0, status: 'Revised Article', path: 'article.revisedArticle' },
  { title: 'Approved', status: 'Approved Article', icon: 'check-circle', value: 0, path: 'article.approvedArticle' },
  { title: 'Accepted', status: 'Accepted Article', icon: 'star', value: 0, path: 'article.acceptedArticles' },
  { title: 'Under Composing', icon: 'edit', value: 0, status: 'Composing Article', path: 'article.composingArticle' },
  { title: 'Galley Proof / Reprints', icon: 'form', value: 0, path: 'article.galleyProof', status: 'Galley Proof' },
  { title: 'DOI Generation', icon: 'snippets', value: 0, status: 'DOI', path: 'article.DOIArticle' },
  { title: 'Online Published', icon: 'menu', value: 0, path: 'article.OnlinePublishArticle', status: 'Online Publish' },
  { title: 'Published Article', icon: 'mail', value: 0, path: 'article.CompletePublication', status: 'Published Article' },
  { title: 'Withdrawal', icon: 'logout', value: 0, path: 'article.WithdrawArticles', status: 'Withdrawled' },
  { title: 'Deleted', icon: 'delete', value: 0, path: 'article.DeletedArticles', status: 'Deleted' }
];

class EditorialWorkflowDrawer extends Component {
  state = {
    fullCards: JSON.parse(JSON.stringify(oldArticleStatusList))
  };

  // componentDidUpdate(prevProps) {
  //   // Automatically fetch fresh data from the API when the drawer opens
  //   if (this.props.visible && !prevProps.visible) {
  //     this.fetchDashboardData({});
  //   }
  // }
  componentDidMount() {
    if (this.props.visible) {
      this.fetchDashboardData({});
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.fetchDashboardData({});
    }
  }
  fetchDashboardData = async (filter = {}) => {
    let { success, data } = await this.props.dispatch(GetDashboardCount(filter));

    if (success) {
      const updatedCards = this.state.fullCards.map((item) => {
        let val = 0;
        if (item.status && data[item.status] !== undefined) {
          val = data[item.status];
        } else if (data[item.title] !== undefined) {
          val = data[item.title];
        }
        return { ...item, value: val };
      });
      this.setState({ fullCards: updatedCards });
    }
  };

  render() {
    const { visible, onClose, dispatch } = this.props;

    return (
      <Drawer
        title="All Article Submissions"
        placement="right"
        closable={true}
        onClose={onClose}
        visible={visible}
        width="87%"
      >
        <div className="dashboardCard">
          <DashboardFilter callback={(filterData) => {
            this.fetchDashboardData(filterData);
          }} />

          <Row gutter={10} className="statusRow">
            {this.state.fullCards.map((item, key) => (
              <Col key={key} lg={4} md={8} sm={12} xs={24} className="statusColumn">
                <Card className="active">
                  <div>
                    <center>
                      <a onClick={() => {
                        onClose();
                        dispatch(getPushPathWrapper(item.path));
                      }}>
                        <div className="title">
                          {item.title}
                        </div>
                        <div className="iconDiv">
                          <Icon type={item.icon} />
                        </div>
                        <div className="date">
                          {item.value}
                        </div>
                      </a>
                    </center>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Drawer>
    );
  }
}

export default connect()(EditorialWorkflowDrawer);